import { faker } from '@faker-js/faker';
import {
  ClinicalTrialInventoryInstrumentType,
  ClinicalTrialInventoryMeasurementType,
  ClinicalTrialInventoryScoringFormType,
} from '@dynamika-shared/types/clinicalTrialInventory';

const codes: ClinicalTrialInventoryScoringFormType['code'][] = [
  'GENANT_L1_SCORING_FORM',
  'GENANT_ADJUDICATION_SCORING_FORM',
  'DXA_ELIGIBILITY_SCORING_FORM',
];

export function createClinicalTrialInventoryScoringForm(
  code: ClinicalTrialInventoryScoringFormType['code']
): ClinicalTrialInventoryScoringFormType {
  return {
    id: faker.string.uuid(),
    clinicalTrialId: faker.string.uuid(),
    code,
    description: faker.lorem.paragraph(),
    extractor: faker.lorem.paragraph(),
    name: faker.company.name(),
    schema: {},
    viewerEmbedded: [
      'GENANT_L1_SCORING_FORM',
      'GENANT_ADJUDICATION_SCORING_FORM',
    ].includes(code),
    attachedFormView: null,
    detachedFormView: null,
    signRequired: true,
  };
}

export function createClinicalTrialInventoryMesurement(
  code: ClinicalTrialInventoryScoringFormType['code']
): ClinicalTrialInventoryMeasurementType {
  return {
    id: faker.string.uuid(),
    clinicalTrialId: faker.string.uuid(),
    code,
    namePattern: 'TL_**',
    description: faker.lorem.paragraph(),
    maxAllowance: faker.number.int(100),
    name: faker.company.name(),
    scoringFormId: faker.string.uuid(),
    screenshotRequired: false,
    allowNaScreenshot: false,
    minRequired: faker.number.int(100),
    metadata: {},
  };
}

export function createClinicalTrialInventoryInstrument(
  code: ClinicalTrialInventoryScoringFormType['code']
): ClinicalTrialInventoryInstrumentType {
  return {
    id: faker.string.uuid(),
    clinicalTrialId: faker.string.uuid(),
    code,
    description: faker.lorem.paragraph(),
    name: faker.company.name(),
    scoringFormId: faker.string.uuid(),
    forImagingSpecialist: true,
    forReader: true,
  };
}

export function createClinicalTrialInventoryScoringFormsList(): ClinicalTrialInventoryScoringFormType[] {
  return codes.map(createClinicalTrialInventoryScoringForm);
}

export function createClinicalTrialInventoryMeasurementsList(): ClinicalTrialInventoryMeasurementType[] {
  return codes.map(createClinicalTrialInventoryMesurement);
}

export function createClinicalTrialInventoryInstrumentList(): ClinicalTrialInventoryInstrumentType[] {
  return codes.map(createClinicalTrialInventoryInstrument);
}
